import { render, staticRenderFns } from "./SelectButtons.vue?vue&type=template&id=3c752e42&scoped=true&"
import script from "./SelectButtons.vue?vue&type=script&lang=js&"
export * from "./SelectButtons.vue?vue&type=script&lang=js&"
import style0 from "./SelectButtons.vue?vue&type=style&index=0&id=3c752e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c752e42",
  null
  
)

export default component.exports